import { createAsyncThunk, unwrapResult } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import { api } from 'src/Services/api'
import { APP } from 'src/Configs/App'

import { NameSpace, ErrorCode } from '../types'
import { getPlaylists } from '../playlists-process/api-actions'

import { mapLevelsWithPlaylists } from './helpers'

export interface CuratorLevelResponse {
  rank: number
  scoreRequired: number
  rewardWithPlacement: number
  rewardWithoutPlacement: number
  rewardPerReview: number
}

export const getLevels = createAsyncThunk(
  `${NameSpace.CURATOR_LEVELS}/getLevels`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get<CuratorLevelResponse[]>(
        `${APP.TIKTOK_SERVER}/curator/review-rewards/ranks`,
      )
      return data
    } catch (error) {
      const { message, response } = error as AxiosError
      return rejectWithValue({
        message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)

export const getLevelsWithPlaylists = createAsyncThunk(
  `${NameSpace.CURATOR_LEVELS}/getLevelsWithPlaylists`,
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const levels = await dispatch(getLevels())
      const playlists = await dispatch(getPlaylists())

      const playlistsData = unwrapResult(playlists)
      const levelsData = unwrapResult(levels)

      return mapLevelsWithPlaylists(levelsData, playlistsData)
    } catch (error) {
      const { message, response } = error as AxiosError
      return rejectWithValue({
        message,
        code: response?.status || ErrorCode.InternalServerError,
      })
    }
  },
)
